import * as Yup from 'yup';

export const step1ValidationSchema = Yup.object({
  labChoice: Yup.string().required('Please select a lab'),
  requestDate: Yup.string().required('Please select a preferred testing date')
});

export const step2ValidationSchema = Yup.object({
  firstName: Yup.string().required('Please enter your first name'),
  lastName: Yup.string().required('Please enter your last name'),
  dateOfBirth: Yup.string().required('Please enter your date of birth'),
  phoneNumber: Yup.string()
    .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Please enter a valid phone number in format (XXX) XXX-XXXX')
    .required('Please enter your phone number'),
  emailAddress: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter your email address'),
  addressLine1: Yup.string().required('Please enter your address'),
  city: Yup.string().required('Please enter your city'),
  state: Yup.string().required('Please select your state'),
  zipCode: Yup.string()
    .matches(/^\d{5}$/, 'Please enter a valid 5-digit zip code')
    .required('Please enter your zip code')
});

export const step3ValidationSchema = Yup.object({
  birthGender: Yup.string().required('Please select your birth gender'),
  raceEthnicity: Yup.string().required('Please select your race/ethnicity'),
  householdIncome: Yup.string().required('Please select your household income range'),
  insuranceStatus: Yup.string().required('Please select your insurance status')
});

export const step4ValidationSchema = Yup.object({
  priorConditions: Yup.array(),
  referredToCardiologist: Yup.string().required('This field is required')
});

export const step5ValidationSchema = Yup.object({
  procedureRisksAcknowledgement: Yup.boolean()
    .oneOf([true], 'You must acknowledge the BHA Waiver & Consent Form')
    .required('You must acknowledge the BHA Waiver & Consent Form')
});

export const step6ValidationSchema = Yup.object({
  dataSharingPermission: Yup.string().required('Data sharing preference is required'),
  heartGuardChampionOptIn: Yup.string().required('Heart Guard Champion opt-in preference is required')
});

export const validationSchemas = [
  step1ValidationSchema,
  step2ValidationSchema,
  step3ValidationSchema,
  step4ValidationSchema,
  step5ValidationSchema,
  step6ValidationSchema
];
